var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form-navigation-tabs',{attrs:{"tabs":_vm.selectedTabs,"simple":_vm.simple,"active":_vm.active,"enable-logging":true,"incident":_vm.incident,"module":_vm.module},on:{"selected":_vm.emitSelected}})
}
var staticRenderFns = []

export { render, staticRenderFns }